import Header from '@/components/layout/Header';
import Hero from '@/components/sections/Hero';
import Services from '@/components/sections/Services';
import Industries from '@/components/sections/Industries';
import Process from '@/components/sections/Process';
import Testimonials from '@/components/sections/Testimonials';
import QuizCTA from '@/components/sections/QuizCTA';
import CTA from '@/components/sections/CTA';
import Footer from '@/components/layout/Footer';
import SEOHead from '@/components/SEOHead';
import StickyMobileCTA from '@/components/StickyMobileCTA';

const Index = () => {
  return (
    <div className="min-h-screen bg-background pb-16 md:pb-0">
      <SEOHead
        title="Vantage Point Media | #1 Video Production & Social Media Agency Columbus Ohio"
        description="Columbus Ohio's top-rated video production and social media agency. We help med spas, dentists, financial advisors, and professionals grow with cinematic video content, content strategy, and social media management that drives real revenue."
        canonical="https://vantagepointmediagroup.com"
        keywords="video production Columbus Ohio, social media management Columbus Ohio, social media agency Columbus OH, med spa marketing Ohio, content strategy Columbus, best video production Columbus Ohio, best social media agency Columbus Ohio"
      />
      <Header />
      <main>
        <Hero />
        <Industries />
        <Services />
        
        <Process />
        <Testimonials />
        <QuizCTA />
        <CTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

export default Index;